import { checkForecastPlusAccess } from "./AuthMethods";

export default function Track(event, properties, pageLoad) {
  if (typeof window !== 'undefined' && window.emAna) {
    const hasAccess = checkForecastPlusAccess();
    let eventProp;

    if(!properties) {
      eventProp = { hasAccess: hasAccess }
    }
    else {
      eventProp = properties;
      eventProp.hasAccess = hasAccess;
    }
    
    if(pageLoad) {
      window.emAna('track', event, eventProp);
    }
    else {
      window.emAna('track', 'PremiumForecast-' + event, eventProp);
    }
  }
}
